var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group 5"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"9-ARCHIVE-","transform":"translate(-23.000000, -2080.000000)","stroke":"#000000","strokeWidth":"0.88"},React.createElement("g",{"id":"Group-5","transform":"translate(23.000000, 2080.000000)"},[React.createElement("polyline",{"id":"Stroke-1","strokeLinecap":"square","strokeLinejoin":"bevel","points":"5.907088 11.81444 0.311168 6.21852 5.907088 0.62172","key":0}),React.createElement("line",{"x1":"0.310904","y1":"6.218168","x2":"14.301144","y2":"6.218168","id":"Stroke-3","key":1})])))]);
}

ArrowLeftInline.defaultProps = {"width":"15px","height":"13px","viewBox":"0 0 15 13","version":"1.1"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
